<script>
import baseList from "@/views/components/base/baseList.vue";
import Vue from "vue";
export default {
    extends: baseList,
    components: {
    },
    data() {
        return {
            table: {
                mname: "engineer",
                key: "id",
                url: {
                    list: "/admin/system/facilityCheck/list",
                    del: "/admin/system/patrol",
                },
                output: false,
                order: "createTime",
            },
            query: {
            },
            actions: [
            ],
            menus: [
                {
                    label: "每日巡检",
                    name: "every_inspection_list",
                    auth: ""
                },
                {
                    label: "每日盘点",
                    name: "every_inventory_list",
                    auth: ""
                }
                // {
                //   label: "定时巡检",
                //   name: "inspection_list",
                //   auth: "system/inspection/index",
                // },
                // {
                //   label: "巡检列表",
                //   name: "inspection_list",
                //   auth: "system/inspection/index",
                // },
                // {
                //   label: "模板管理",
                //   name: "templateManagement_list",
                //   auth: "system/templateManagement/index",
                // },
                // { label: "场景管理", name: "scene_list", auth: "system/scene/index" },
            ],
            filters: [
                // {
                //   label: "负责人",
                //   KeyEnter: this.search,
                //   name: "maintainerId",
                //   value: "",
                //   type: "select",
                //   dropList: [],
                // },
                // {
                //   label: "巡检名称",
                //   KeyEnter: this.search,
                //   name: "patrolName",
                //   value: "",
                //   type: "input",
                // },
            ],
            tableCols: [
                {
                    title: "序号",
                    type: "index",
                    width: 80,
                    align: "center",
                },
                // {
                //   title: "巡检名称",
                //   key: "patrolName",
                //   minWidth: 120,
                //   align: "left",
                //   render: (h, params) => {
                //     const row = params.row;
                //     const text = row.patrolName;
                //     return (
                //       <span
                //         style={{
                //           color: row.state == 1 ? "red" : "",
                //         }}
                //       >
                //         {text}
                //       </span>
                //     );
                //   },
                // },
                {
                    title: "资产名称",
                    key: "facilityName",
                    minWidth: 120,
                    align: "left",
                },
                {
                    title: "盘点信息",
                    key: "content",
                    minWidth: 200,
                    align: "left",
                },
                {
                    title: "盘点人",
                    key: "createBy",
                    minWidth: 100,
                    align: "left",
                },
                {
                    title: "盘点时间",
                    key: "createTime",
                    minWidth: 120,
                    align: "left",
                },
                // {
                //   title: "操作",
                //   align: "center",
                //   width: 210,
                //   key: "handle",
                //   fixed: "right",
                //   handle: [
                //     // (vm, h, currentRow, param) => {
                //     //   let directives = [{ name: 'auth', value: '/admin/inspection/edit' }]
                //     //   return (
                //     //     <Button {...{ directives }} size="small" onClick={() => this.toAdd(currentRow)} type="text" style={{ margin: '0', color: '#66A2FF' }}>
                //     //       编辑
                //     //     </Button>
                //     //   )
                //     // },
                //     // (vm, h, currentRow, param) => {
                //     //   // let directives = []
                //     //   let directives = [
                //     //     { name: "auth", value: "system/inspection/check" },
                //     //   ];
                //     //   return (
                //     //     <Button
                //     //       {...{ directives }}
                //     //       size="small"
                //     //       onClick={() => this.toCheck(currentRow)}
                //     //       type="default"
                //     //       style={{
                //     //         border:"none",
                //     //         color: "#4991ff",marginRight: "5px" }}
                //     //     >
                //     //       巡检记录
                //     //     </Button>
                //     //   );
                //     // },
                //     // (vm, h, currentRow, param) => {
                //     //   // let directives = []
                //     //   let directives = [
                //     //     { name: "auth", value: "system/inspection/info" },
                //     //   ];
                //     //   return (
                //     //     <Button
                //     //       {...{ directives }}
                //     //       size="small"
                //     //       onClick={() => this.toinfo(currentRow)}
                //     //       type="default"
                //     //       style={{
                //     //         border:"none",
                //     //         color: "#4991ff",margin: "0" }}
                //     //     >
                //     //       详情
                //     //     </Button>
                //     //   );
                //     // },
                //     "delete",
                //   ],
                //   auth: {
                //     // edit: "system/knowledgeBaseTag/edit",
                //     del: "system/inspection/delete",
                //   },
                // },
            ],
        };
    },
    created() {
        let maintainerId = window.localStorage.getItem('engineerQuery')
        if (maintainerId) {
            this.query.maintainerId = maintainerId
        }
    },
    methods: {
        toInspection(row = {}) {
            $utils.url.replace({
                name: "every_inspection_list",
                query: this.query,
            });
        },
        toInventory(row = {}) {
            $utils.url.replace({
                name: "every_inventory_list",
                query: this.query,
            });
        },
    },
};
</script>
<style scoped></style>
